// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddLaborItemModal_GlobalPlanTasksQueryVariables = Types.Exact<{
  filter: Types.GlobalPlanTaskFilter;
}>;


export type AddLaborItemModal_GlobalPlanTasksQuery = { __typename?: 'Query', globalPlanTasks: { __typename?: 'GlobalPlanTasksPageResult', entities: Array<{ __typename?: 'GlobalPlanTask', id: string, name: string }> } };

export type AddLaborItemModal_EffectiveLocationsQueryVariables = Types.Exact<{
  filter: Types.LocationsFilter;
}>;


export type AddLaborItemModal_EffectiveLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, path?: string | null | undefined, name: string, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }> };


export const AddLaborItemModal_GlobalPlanTasksDocument = gql`
    query AddLaborItemModal_GlobalPlanTasks($filter: GlobalPlanTaskFilter!) {
  globalPlanTasks(filter: $filter, page: {limit: 10000}) {
    entities {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useAddLaborItemModal_GlobalPlanTasksQuery__
 *
 * To run a query within a React component, call `useAddLaborItemModal_GlobalPlanTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddLaborItemModal_GlobalPlanTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddLaborItemModal_GlobalPlanTasksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddLaborItemModal_GlobalPlanTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables> & ({ variables: AddLaborItemModal_GlobalPlanTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>(AddLaborItemModal_GlobalPlanTasksDocument, options);
      }
export function useAddLaborItemModal_GlobalPlanTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>(AddLaborItemModal_GlobalPlanTasksDocument, options);
        }
// @ts-ignore
export function useAddLaborItemModal_GlobalPlanTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>;
export function useAddLaborItemModal_GlobalPlanTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddLaborItemModal_GlobalPlanTasksQuery | undefined, AddLaborItemModal_GlobalPlanTasksQueryVariables>;
export function useAddLaborItemModal_GlobalPlanTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>(AddLaborItemModal_GlobalPlanTasksDocument, options);
        }
export type AddLaborItemModal_GlobalPlanTasksQueryHookResult = ReturnType<typeof useAddLaborItemModal_GlobalPlanTasksQuery>;
export type AddLaborItemModal_GlobalPlanTasksLazyQueryHookResult = ReturnType<typeof useAddLaborItemModal_GlobalPlanTasksLazyQuery>;
export type AddLaborItemModal_GlobalPlanTasksSuspenseQueryHookResult = ReturnType<typeof useAddLaborItemModal_GlobalPlanTasksSuspenseQuery>;
export type AddLaborItemModal_GlobalPlanTasksQueryResult = Apollo.QueryResult<AddLaborItemModal_GlobalPlanTasksQuery, AddLaborItemModal_GlobalPlanTasksQueryVariables>;
export const AddLaborItemModal_EffectiveLocationsDocument = gql`
    query AddLaborItemModal_EffectiveLocations($filter: LocationsFilter!) {
  locations(filter: $filter, effectiveLocations: true) {
    id
    path
    name
    displayLocationPath
    type {
      code
      name
    }
  }
}
    `;

/**
 * __useAddLaborItemModal_EffectiveLocationsQuery__
 *
 * To run a query within a React component, call `useAddLaborItemModal_EffectiveLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddLaborItemModal_EffectiveLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddLaborItemModal_EffectiveLocationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddLaborItemModal_EffectiveLocationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables> & ({ variables: AddLaborItemModal_EffectiveLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>(AddLaborItemModal_EffectiveLocationsDocument, options);
      }
export function useAddLaborItemModal_EffectiveLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>(AddLaborItemModal_EffectiveLocationsDocument, options);
        }
// @ts-ignore
export function useAddLaborItemModal_EffectiveLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>;
export function useAddLaborItemModal_EffectiveLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddLaborItemModal_EffectiveLocationsQuery | undefined, AddLaborItemModal_EffectiveLocationsQueryVariables>;
export function useAddLaborItemModal_EffectiveLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>(AddLaborItemModal_EffectiveLocationsDocument, options);
        }
export type AddLaborItemModal_EffectiveLocationsQueryHookResult = ReturnType<typeof useAddLaborItemModal_EffectiveLocationsQuery>;
export type AddLaborItemModal_EffectiveLocationsLazyQueryHookResult = ReturnType<typeof useAddLaborItemModal_EffectiveLocationsLazyQuery>;
export type AddLaborItemModal_EffectiveLocationsSuspenseQueryHookResult = ReturnType<typeof useAddLaborItemModal_EffectiveLocationsSuspenseQuery>;
export type AddLaborItemModal_EffectiveLocationsQueryResult = Apollo.QueryResult<AddLaborItemModal_EffectiveLocationsQuery, AddLaborItemModal_EffectiveLocationsQueryVariables>;